import { useEffect, useRef, useState } from "react";
import { Icon, type IconName } from "../../components/ui/Icon";
import { Sheet } from "../../components/ui/Sheet";
import type { LogEntry } from "./runEvents";

const ICON: Record<LogEntry["k"], IconName> = { call: "tool", think: "bulb", note: "toggle", err: "x" };

function Row({ e, hi }: { e: LogEntry; hi: boolean }) {
  const [open, setOpen] = useState(false);
  const det = e.i !== undefined || e.o !== undefined;
  const raw = [
    e.tool ? `tool\n${e.tool}\n\n` : "",
    e.i !== undefined ? `input\n${JSON.stringify(e.i, null, 2)}\n\n` : "",
    e.o !== undefined ? `output\n${typeof e.o === "string" ? e.o : JSON.stringify(e.o, null, 2)}` : "",
  ].join("");
  return (
    <div className={`lr ${e.k}${hi ? " hi" : ""}${det ? " det" : ""}`} onClick={det ? () => setOpen((o) => !o) : undefined}>
      <span className="lt">{e.t}</span>
      <span className="li">
        <Icon name={ICON[e.k]} />
      </span>
      <div className="lx">
        <span className="ltx">{e.x}</span>
        {det && <span className="lmore">{open ? "Hide" : "Details"}</span>}
        {open && <pre className="raw">{raw}</pre>}
      </div>
    </div>
  );
}

/** The prototype's planning log sheet: every step of a run, with Details for what went in and came back. */
export function RunLogSheet({ open, onClose, title, sum, log, hi }: { open: boolean; onClose: () => void; title: string; sum: string; log: LogEntry[]; hi?: Set<string> }) {
  const rows = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open || !hi?.size) return;
    const t = setTimeout(() => rows.current?.querySelector(".hi")?.scrollIntoView({ block: "center" }), 200);
    return () => clearTimeout(t);
  }, [open, hi]);
  return (
    <Sheet open={open} onClose={onClose} label={title}>
      <h2>{title}</h2>
      <p className="logsum mono" style={{ marginTop: 6 }}>
        {sum}
      </p>
      <div className="card log" style={{ marginTop: 10 }} ref={rows}>
        {log.map((e) => (
          <Row key={e.key} e={e} hi={!!hi?.has(e.key)} />
        ))}
      </div>
      <div className="note-line">
        <Icon name="lock" />
        <span>Thoughts are the agent's own words, trimmed.</span>
      </div>
    </Sheet>
  );
}
